import CategoryPage from "@/components/CategoryPage";
import { CATEGORY_PAGES } from "@/data/categories";

export default function TileAdhesives() {
  return <CategoryPage page={CATEGORY_PAGES.tileAdhesives} testId="tile-adhesives-page" />;
}
